import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const courseList = createAsyncThunk('courseList', async ({ pageable: data, navigate, status, type }) => { try { const res = await axios({ method: 'GET',
            url: getConfig.API_URL + `course?status=${status || ''}`,
            params: { 'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(data?.instituteId !== undefined && data?.instituteId !== null && data?.instituteId !== ''
                    ? { institute_id: data.instituteId }
                    : {}),
                ...(type ? { type } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) { return error.response
    }
})

const courseListSlice = createSlice({ name: 'courseList',
    initialState: { data: [],
    },
    extraReducers: (builder) => { builder.addCase(courseList.fulfilled, (state, action) => { if (action?.payload?.status === 200) { state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) { showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) { showAccessDeniedAlert(action.meta.arg.navigate)
            } else { state.data = []
            }

        });
        builder.addCase(courseList.rejected, (state, action) => { // console.log('reject', action)
        })
    }
})

export default courseListSlice.reducer;
